export const ENTRYPOINT = process.env.BASE_URL;
export const ENTRYPOINT_PUBLIC = process.env.BASE_URL_PUBLIC;
